export enum ChestAnimationStatusEnum {
  APPEARS = 'APPEARS',
  JUMPING = 'JUMPING',
  OPENING = 'OPENING',
  SHOWING = 'SHOWING',
  OPENED = 'OPENED',
}
